// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3KYex","additionalInfo":"AgreementModal_additionalInfo__2-KWJ"};